const comments = [
  {
    name: '追剧达人小王',
    time: '3天前',
    content: '老子影视网真的太好用了！画质高清而且完全不卡顿，追《玫瑰的故事》全集一气呵成，推荐给所有剧荒的朋友！',
    rating: 5,
  },
  {
    name: '韩剧迷妹小陈',
    time: '5天前',
    content: '找了好久能看韩剧全集的平台，终于在这里找到了！《好搭档》更新好快，字幕也很清晰，好评！',
    rating: 5,
  },
  {
    name: '古装控阿明',
    time: '1周前',
    content: '国产剧全集资源太全了，从经典老剧到最新热播都有。高清画质不缓冲这个真的没话说，上班摸鱼追剧首选。',
    rating: 5,
  },
  {
    name: '学生党小李',
    time: '1周前',
    content: '室友推荐的这个站，电视剧在线播放很方便，手机上也能看，不用下载App，宿舍Wi-Fi看高清也很流畅。',
    rating: 4,
  },
  {
    name: '剧评人老张',
    time: '2周前',
    content: '作为一个阅剧无数的老观众，老子影视网的片源质量确实不错。分类清晰，更新及时，免费观看真的很良心。',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          观众评价
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          来自追剧同好的真实反馈
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.map((item, idx) => (
            <div
              key={idx}
              className={`bg-background-50 rounded-xl p-5 border border-background-200/60 ${
                idx === 3 && comments.length > 4 ? 'lg:col-start-2' : ''
              }`}
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed mb-4">
                {item.content}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-foreground-900">{item.name}</span>
                <span className="text-xs text-foreground-500">{item.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}